<template>
  <div class="cart-config">
    <div class="page-header"><h2><span class="breadcrumb-level">订单管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">订单设置</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">购物车设置</span></h2></div>
    <el-card>
      <template #header>      </template>

      <el-form :model="form" label-width="180px" ref="formRef">
        <el-form-item label="购物车商品种类上限" prop="max_items"
          :rules="[{ required: true, message: '请输入上限数量', trigger: 'blur' }, { type: 'number', min: 1, max: 100, message: '范围 1-100', trigger: 'blur' }]"
        >
          <el-input-number v-model="form.max_items" :min="1" :max="100" />
          <span class="unit">种</span>
        </el-form-item>

        <el-form-item label="单种商品数量上限" prop="max_per_item"
          :rules="[{ required: true, message: '请输入上限数量', trigger: 'blur' }, { type: 'number', min: 1, max: 100, message: '范围 1-100', trigger: 'blur' }]"
        >
          <el-input-number v-model="form.max_per_item" :min="1" :max="100" />
          <span class="unit">件</span>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSave" :loading="saving">保存</el-button>
          <el-button @click="fetchData">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import * as api from '../../api/orders'

const saving = ref(false)
const formRef = ref(null)
const form = reactive({
  max_items: 20,
  max_per_item: 20,
})

const fetchData = async () => {
  try {
    const res = await api.getCartConfig()
    const data = res.data || {}
    form.max_items = data.max_items || 20
    form.max_per_item = data.max_per_item || 20
  } catch (e) {
    ElMessage.error('加载失败')
  }
}

const handleSave = async () => {
  const valid = await formRef.value.validate().catch(() => false)
  if (!valid) return
  saving.value = true
  try {
    await api.updateCartConfig({ max_items: form.max_items, max_per_item: form.max_per_item })
    ElMessage.success('保存成功')
  } catch (e) {
    ElMessage.error('保存失败')
  } finally {
    saving.value = false
  }
}

onMounted(fetchData)
</script>

<style scoped>
.cart-config {
  max-width: 600px;
}
.unit {
  margin-left: 10px;
  color: #999;
  font-size: 14px;
}
</style>
